const env = process.env.NODE_ENV || 'development';
const isFrontEnd = (typeof window !== 'undefined');
const location = isFrontEnd ? window.location : { protocol: 'http:', hostname: 'localhost' };
const isStage = isFrontEnd ? location.hostname === 'sta.17.media' : process.env.NODE_ENV === 'stage' ;
const isDev = env === 'development';
const constants = {
  development: {
    API_URL: `${location.protocol}//${location.hostname}:8080`,
    defaultLiveOpenID: 'lance.cheng',
  },

  production: {
    API_URL: 'https://api-dsa.17app.co',
    defaultLiveOpenID: '17media',
  },
};

const config = constants[env];
module.exports = { env, config , isStage, isDev };


// WEBPACK FOOTER //
// ./src/lib/constants.js